module.exports = __webpack_public_path__ + "img/404.f5332417.png";